module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-timeline",
    class: _vm.displayClass
  }, [_c('div', {
    staticClass: "c-timeline__progress",
    style: (_vm.scaleX)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-090e2344!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline/Timeline.vue
// module id = 84
// module chunks = 2